import React from 'react';
import { Link } from 'react-router-dom';
import work1 from '../../../assets/p1.png'
const Project1 = () => {
    const projectsData =
    {
        id: 1,
        image: work1,
        title: "BuySellRepeat",
        description: "Full-Stack MERN Projects",
        link: "https://assignment-12-9aa5e.web.app/",
        go: "/project1"
    };
    return (
        <div className='mt-[70px]'>

            <h1 className='text-center text-5xl font-bold mb-10'>Welcome to my project</h1>
            <div className=''>
                <img className='w-1/2 mx-auto' src={projectsData.image} alt="" />
            </div>
            <div className='w-1/2 mx-auto mt-10 flex flex-row-reverse'>
                <Link to='/project2' className='btn btn-warning'>Next project</Link>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2 className='text-3xl text-info'>BuySellRepeat- A resale market place for old and unused computer products.</h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Built with: React, Tailwind, Express, NodeJS, MongoDB, Express js.</h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Feature included: Firebase Authentication, Private route, React-router-dom, CRUD operation, Service page, env variable, payment, axios, query function, and JWT token for ensure more security, Blog page, vercel for server deploy. </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Key Features:
                    <br /><br />
                    1. This is a resale market place for old and unused product, this site will help anyone interested to buy or
                    sale their unused goods for a good reasonable price.
                    <br /><br />
                    2. Admin, Buyer and Seller dashboard.
                    <br /><br />
                    3. User can visit the site and check any items without login, they can see product's price and detail information.
                    <br />
                    -Any User can open a account and sell their product by adding them with enough information.
                    <br />
                    -they Also can find a donation option for donating their unused product to the unprivileged people.
                    <br />
                    -also they can give advertisement about their unsold product.


                </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <a className='button' target='_blank' rel="noopener noreferrer" href="https://github.com/RAZYANIK/buySellRepeat-client-repo">Client site Git Link</a>
                <a className='button ml-10' href="https://github.com/RAZYANIK/BuySellRepeat-server-site-repo" target='_blank' rel="noopener noreferrer">Server site Git Link</a>
            </div>
        </div>
    );
};

export default Project1;